import React from 'react';
import FooterFinal from '../components/FooterFinal';
import CountdownTimer from '../components/CountdownTimer';
import SimpleMap from '../components/Maps';
import QRCodeCanvas from '../components/QRCode';
import styles from '../templates/colors/purple.module.css';

/*INSTRUÇÕES */
/*Nome do Evento*/
const event = 'Bday Renata Chaves'
const phrase = 'Você está intimado à comparecer ao meu aniversário! Vem aí:'

/* Data do evento */
const defaultEndDate = new Date("Feb 11, 2023 23:59:59");

/* Data e hora*/
const date = '11/02/2023'
const hour = 'horário ainda a definir'

/* Endereço */
const street ='Rua dos Bobos';
const number = '0';
const city = 'São Paulo';
const uf = 'SP';

/*Coordenadas Mapa */
const location = {
  center: {
    lat: -19.9026615,
    lng: -44.1041402,
  },
  zoom: 11
};

/*Infos do evento*/
const info = 'Presença indispensável'


/*Convite para donwload */
const confirmationLink = 'https://wa.me/+5543996079439?text=Oi+Renata%21+Irei+ao+seu+anivers%C3%A1rio'

const inviteFile = 'https://drive.google.com/file/d/1ORomgeTsTXmmeW5Dbg3b7Hk8HJU6Hbmm/view?usp=sharing'

/*QR Code */
const url = 'https://techconvite.ga/bday/renata-chaves'


export default function PostRenataChaves() {
  return (
      <>
      
      <div className={styles.body}>
          <div className={styles.header}>
            <h2>{phrase}</h2>
            <h1>{event}</h1>
            <h2>Faltam exatamente:</h2>
          </div>
      </div>
        
      <div className={styles.content}>
        
          <div className={styles.contentCountdown}>
            <div className={styles.countdown}>
                <CountdownTimer targetDate={defaultEndDate}/> 
            </div>
          </div>      
      </div>

          <div className={styles.contentEventData}>

                <div className={styles.eventData}>
                  <i class="fa-solid fa-calendar-days"></i>
                    <p>Espero você em</p>
                    <p>{date} às {hour}</p>
                  {/* <h2>Já coloca na sua agenda!</h2> */}
                </div>

                <div className={styles.eventData}>
                  <i class="fa-solid fa-map-location-dot"></i>
                  {/* <h2>Onde vai ser?</h2> */}
                  <p>{street}, nº {number}.</p>
                  <p>{city} - {uf}</p>
                </div>
          </div>

          <div className={styles.contentEventData}>

            <div className={styles.eventData}>
              <i class="fa-solid fa-triangle-exclamation"></i>
              <p>{info}</p>
            </div>

          </div>


          <div className={styles.contentEventMap}>

            
              <div className={styles.googleMaps}>
                <SimpleMap 
                  location={location}
                />
              </div>
          </div>
          
          <div className={styles.contentEventData}>

            <div className={styles.eventData}>
              <button className={styles.button}>
                <a href={confirmationLink}> 
                    <i class="fa-brands fa-whatsapp"></i> 
                </a>
              </button>
                <p>Confirme sua presença</p>
            
            </div>

            <div className={styles.eventData}>
                <button className={styles.button}>
                  <a href={inviteFile}>
                      <i class="fa-solid fa-circle-down"></i>
                      </a>
                </button>
                <p>Salve o Convite</p>
            </div>
      
          </div>

          <div className={styles.contentEventData}> 
            <div className={styles.eventData}>
                  <p>QR Code Exclusivo do Evento</p>
                  <QRCodeCanvas
                  url={url}
                  />                
            </div>
         
          </div>

      <FooterFinal/>
    </>
)};